import { useMutation } from 'react-query';
import { fetchInquiryCreate, InquiryCreate } from '@/api/inquiries';

function useInquiryCreate() {
  return useMutation((params: InquiryCreate) => fetchInquiryCreate(params));
}

export default useInquiryCreate;
